import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X, Lock } from "lucide-react";
import { BUSINESS } from "../../lib/constants";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/catalog", label: "Catalog", testid: "nav-catalog-link" },
  { to: "/custom-orders", label: "Custom Orders", testid: "nav-custom-orders-link" },
  { to: "/blog", label: "Insights", testid: "nav-blog-link" },
  { to: "/quote", label: "Request Quote", testid: "nav-quote-link" },
];

export function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/80 border-b border-amber-500/20" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-home-logo">
          <img src={BUSINESS.logo} alt={BUSINESS.name} className="h-11 w-11 rounded-full object-cover group-hover:rotate-12 transition-transform duration-500" />
          <span className="font-display text-xl md:text-2xl text-white tracking-wide leading-none">
            ORION <span className="text-amber-light">SERVICES</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-sm font-mono uppercase tracking-widest transition-colors hover:text-amber-light ${
                  isActive ? "text-amber-light" : "text-zinc-300"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/admin/login"
            data-testid="nav-admin-link"
            className="flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest text-zinc-500 hover:text-amber-light transition-colors border border-amber-500/20 rounded-full px-3 py-1.5"
          >
            <Lock className="h-3 w-3" /> Admin
          </Link>
        </nav>

        <button
          className="lg:hidden text-white"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="lg:hidden overflow-hidden bg-black border-t border-amber-500/10"
          >
            <div className="flex flex-col px-6 py-4 gap-4">
              {[...LINKS, { to: "/admin/login", label: "Admin Login", testid: "nav-admin-link-mobile" }].map((l) => (
                <Link key={l.to} to={l.to} onClick={() => setOpen(false)} data-testid={l.testid} className="text-sm font-mono uppercase tracking-widest text-zinc-300 hover:text-amber-light">
                  {l.label}
                </Link>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
